import { type Command } from '@telespot/core';

/**
 * Details for {@link ListDevices}
 *
 * @group Devices
 * @category Payloads
 */
export interface ListDevicesDetails {
  organizationId?: string;
  limit?: number;
  searchTerm?: string;
  olderThan?: Date;
}

/**
 * Command registration token for {@link ListDevices}
 *
 * @group Devices
 * @category Tokens
 */
export const LIST_DEVICES = 'devices:list';

/**
 * Lists devices.
 */
export class ListDevices implements Command<typeof LIST_DEVICES, ListDevicesDetails> {
  public readonly name = LIST_DEVICES;
  constructor(public readonly details: Readonly<ListDevicesDetails>) {}
}
